module.exports = __webpack_public_path__ + "img/17858_S.1364cb74.png";